import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="app-header">
      <Link to="/" className="brand">
        KROSI<span>FIN</span>
      </Link>
      <nav className="nav-links">
        <Link to="/">Companies</Link>
      </nav>
    </header>
  );
}

export default Header;
